import { default as indexrjkzbMJEF1Meta } from "D:/workFile/taro-trip/src/pages/index.vue?macro=true";
import { default as indexQS5ZMbmdGIMeta } from "D:/workFile/taro-trip/src/pages/aboutUs/index.vue?macro=true";
import { default as indexliUpblsNcHMeta } from "D:/workFile/taro-trip/src/pages/addPassenger/index.vue?macro=true";
import { default as indexcveZ5Ic5wAMeta } from "D:/workFile/taro-trip/src/pages/confirmation/index.vue?macro=true";
import { default as indexKHhm18GylvMeta } from "D:/workFile/taro-trip/src/pages/contactUs/index.vue?macro=true";
import { default as _91id_93e1RGYafy2rMeta } from "D:/workFile/taro-trip/src/pages/destination/[id].vue?macro=true";
import { default as indexg72EyvKE8HMeta } from "D:/workFile/taro-trip/src/pages/familyAndFriends/index.vue?macro=true";
import { default as indexqZ5FikhHlHMeta } from "D:/workFile/taro-trip/src/pages/flightLoading/index.vue?macro=true";
import { default as _91toCity_93U9dVIKora0Meta } from "D:/workFile/taro-trip/src/pages/flights/search/[fromCity]/[toCity].vue?macro=true";
import { default as index2Xrhd53Q3eMeta } from "D:/workFile/taro-trip/src/pages/help/index.vue?macro=true";
import { default as _91id_93jdqKJZ5MqPMeta } from "D:/workFile/taro-trip/src/pages/hotDeals/[id].vue?macro=true";
import { default as _91id_939vVDzalRsbMeta } from "D:/workFile/taro-trip/src/pages/orderDetail/[id].vue?macro=true";
import { default as indexAnlX7r2KdTMeta } from "D:/workFile/taro-trip/src/pages/orderList/index.vue?macro=true";
import { default as indexEFghuiQCy7Meta } from "D:/workFile/taro-trip/src/pages/payComplete/index.vue?macro=true";
import { default as indexTdzzmuGT8mMeta } from "D:/workFile/taro-trip/src/pages/payments/index.vue?macro=true";
import { default as index6HwbC0eKj6Meta } from "D:/workFile/taro-trip/src/pages/personalInformation/index.vue?macro=true";
import { default as indexd2zVSZyrL6Meta } from "D:/workFile/taro-trip/src/pages/policyContent/index.vue?macro=true";
import { default as indexmZQKsbdXAaMeta } from "D:/workFile/taro-trip/src/pages/termService/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexrjkzbMJEF1Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "aboutUs___En",
    path: "/En/aboutUs",
    meta: indexQS5ZMbmdGIMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: "aboutUs___Hk",
    path: "/Hk/aboutUs",
    meta: indexQS5ZMbmdGIMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: "aboutUs___Cn",
    path: "/Cn/aboutUs",
    meta: indexQS5ZMbmdGIMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: "aboutUs___Ja",
    path: "/Ja/aboutUs",
    meta: indexQS5ZMbmdGIMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: "addPassenger___En",
    path: "/En/addPassenger",
    meta: indexliUpblsNcHMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: "addPassenger___Hk",
    path: "/Hk/addPassenger",
    meta: indexliUpblsNcHMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: "addPassenger___Cn",
    path: "/Cn/addPassenger",
    meta: indexliUpblsNcHMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: "addPassenger___Ja",
    path: "/Ja/addPassenger",
    meta: indexliUpblsNcHMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: "confirmation___En",
    path: "/En/confirmation",
    meta: indexcveZ5Ic5wAMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "confirmation___Hk",
    path: "/Hk/confirmation",
    meta: indexcveZ5Ic5wAMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "confirmation___Cn",
    path: "/Cn/confirmation",
    meta: indexcveZ5Ic5wAMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "confirmation___Ja",
    path: "/Ja/confirmation",
    meta: indexcveZ5Ic5wAMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "contactUs___En",
    path: "/En/contactUs",
    meta: indexKHhm18GylvMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: "contactUs___Hk",
    path: "/Hk/contactUs",
    meta: indexKHhm18GylvMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: "contactUs___Cn",
    path: "/Cn/contactUs",
    meta: indexKHhm18GylvMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: "contactUs___Ja",
    path: "/Ja/contactUs",
    meta: indexKHhm18GylvMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: "destination-id___En",
    path: "/En/destination/:id()",
    meta: _91id_93e1RGYafy2rMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/destination/[id].vue").then(m => m.default || m)
  },
  {
    name: "destination-id___Hk",
    path: "/Hk/destination/:id()",
    meta: _91id_93e1RGYafy2rMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/destination/[id].vue").then(m => m.default || m)
  },
  {
    name: "destination-id___Cn",
    path: "/Cn/destination/:id()",
    meta: _91id_93e1RGYafy2rMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/destination/[id].vue").then(m => m.default || m)
  },
  {
    name: "destination-id___Ja",
    path: "/Ja/destination/:id()",
    meta: _91id_93e1RGYafy2rMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/destination/[id].vue").then(m => m.default || m)
  },
  {
    name: "familyAndFriends___En",
    path: "/En/familyAndFriends",
    meta: indexg72EyvKE8HMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/familyAndFriends/index.vue").then(m => m.default || m)
  },
  {
    name: "familyAndFriends___Hk",
    path: "/Hk/familyAndFriends",
    meta: indexg72EyvKE8HMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/familyAndFriends/index.vue").then(m => m.default || m)
  },
  {
    name: "familyAndFriends___Cn",
    path: "/Cn/familyAndFriends",
    meta: indexg72EyvKE8HMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/familyAndFriends/index.vue").then(m => m.default || m)
  },
  {
    name: "familyAndFriends___Ja",
    path: "/Ja/familyAndFriends",
    meta: indexg72EyvKE8HMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/familyAndFriends/index.vue").then(m => m.default || m)
  },
  {
    name: "flightLoading___En",
    path: "/En/flightLoading",
    component: () => import("D:/workFile/taro-trip/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: "flightLoading___Hk",
    path: "/Hk/flightLoading",
    component: () => import("D:/workFile/taro-trip/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: "flightLoading___Cn",
    path: "/Cn/flightLoading",
    component: () => import("D:/workFile/taro-trip/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: "flightLoading___Ja",
    path: "/Ja/flightLoading",
    component: () => import("D:/workFile/taro-trip/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: "flights-search-fromCity-toCity___En",
    path: "/En/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93U9dVIKora0Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: "flights-search-fromCity-toCity___Hk",
    path: "/Hk/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93U9dVIKora0Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: "flights-search-fromCity-toCity___Cn",
    path: "/Cn/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93U9dVIKora0Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: "flights-search-fromCity-toCity___Ja",
    path: "/Ja/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93U9dVIKora0Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: "help___En",
    path: "/En/help",
    meta: index2Xrhd53Q3eMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "help___Hk",
    path: "/Hk/help",
    meta: index2Xrhd53Q3eMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "help___Cn",
    path: "/Cn/help",
    meta: index2Xrhd53Q3eMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "help___Ja",
    path: "/Ja/help",
    meta: index2Xrhd53Q3eMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "hotDeals-id___En",
    path: "/En/hotDeals/:id()",
    meta: _91id_93jdqKJZ5MqPMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/hotDeals/[id].vue").then(m => m.default || m)
  },
  {
    name: "hotDeals-id___Hk",
    path: "/Hk/hotDeals/:id()",
    meta: _91id_93jdqKJZ5MqPMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/hotDeals/[id].vue").then(m => m.default || m)
  },
  {
    name: "hotDeals-id___Cn",
    path: "/Cn/hotDeals/:id()",
    meta: _91id_93jdqKJZ5MqPMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/hotDeals/[id].vue").then(m => m.default || m)
  },
  {
    name: "hotDeals-id___Ja",
    path: "/Ja/hotDeals/:id()",
    meta: _91id_93jdqKJZ5MqPMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/hotDeals/[id].vue").then(m => m.default || m)
  },
  {
    name: "index___En",
    path: "/En",
    meta: indexrjkzbMJEF1Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___Hk",
    path: "/Hk",
    meta: indexrjkzbMJEF1Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___Cn",
    path: "/Cn",
    meta: indexrjkzbMJEF1Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___Ja",
    path: "/Ja",
    meta: indexrjkzbMJEF1Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "orderDetail-id___En",
    path: "/En/orderDetail/:id()",
    meta: _91id_939vVDzalRsbMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: "orderDetail-id___Hk",
    path: "/Hk/orderDetail/:id()",
    meta: _91id_939vVDzalRsbMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: "orderDetail-id___Cn",
    path: "/Cn/orderDetail/:id()",
    meta: _91id_939vVDzalRsbMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: "orderDetail-id___Ja",
    path: "/Ja/orderDetail/:id()",
    meta: _91id_939vVDzalRsbMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: "orderList___En",
    path: "/En/orderList",
    meta: indexAnlX7r2KdTMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/orderList/index.vue").then(m => m.default || m)
  },
  {
    name: "orderList___Hk",
    path: "/Hk/orderList",
    meta: indexAnlX7r2KdTMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/orderList/index.vue").then(m => m.default || m)
  },
  {
    name: "orderList___Cn",
    path: "/Cn/orderList",
    meta: indexAnlX7r2KdTMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/orderList/index.vue").then(m => m.default || m)
  },
  {
    name: "orderList___Ja",
    path: "/Ja/orderList",
    meta: indexAnlX7r2KdTMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/orderList/index.vue").then(m => m.default || m)
  },
  {
    name: "payComplete___En",
    path: "/En/payComplete",
    meta: indexEFghuiQCy7Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: "payComplete___Hk",
    path: "/Hk/payComplete",
    meta: indexEFghuiQCy7Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: "payComplete___Cn",
    path: "/Cn/payComplete",
    meta: indexEFghuiQCy7Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: "payComplete___Ja",
    path: "/Ja/payComplete",
    meta: indexEFghuiQCy7Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: "payments___En",
    path: "/En/payments",
    meta: indexTdzzmuGT8mMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "payments___Hk",
    path: "/Hk/payments",
    meta: indexTdzzmuGT8mMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "payments___Cn",
    path: "/Cn/payments",
    meta: indexTdzzmuGT8mMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "payments___Ja",
    path: "/Ja/payments",
    meta: indexTdzzmuGT8mMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "personalInformation___En",
    path: "/En/personalInformation",
    meta: index6HwbC0eKj6Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/personalInformation/index.vue").then(m => m.default || m)
  },
  {
    name: "personalInformation___Hk",
    path: "/Hk/personalInformation",
    meta: index6HwbC0eKj6Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/personalInformation/index.vue").then(m => m.default || m)
  },
  {
    name: "personalInformation___Cn",
    path: "/Cn/personalInformation",
    meta: index6HwbC0eKj6Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/personalInformation/index.vue").then(m => m.default || m)
  },
  {
    name: "personalInformation___Ja",
    path: "/Ja/personalInformation",
    meta: index6HwbC0eKj6Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/personalInformation/index.vue").then(m => m.default || m)
  },
  {
    name: "policyContent___En",
    path: "/En/policyContent",
    meta: indexd2zVSZyrL6Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/policyContent/index.vue").then(m => m.default || m)
  },
  {
    name: "policyContent___Hk",
    path: "/Hk/policyContent",
    meta: indexd2zVSZyrL6Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/policyContent/index.vue").then(m => m.default || m)
  },
  {
    name: "policyContent___Cn",
    path: "/Cn/policyContent",
    meta: indexd2zVSZyrL6Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/policyContent/index.vue").then(m => m.default || m)
  },
  {
    name: "policyContent___Ja",
    path: "/Ja/policyContent",
    meta: indexd2zVSZyrL6Meta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/policyContent/index.vue").then(m => m.default || m)
  },
  {
    name: "termService___En",
    path: "/En/termService",
    meta: indexmZQKsbdXAaMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/termService/index.vue").then(m => m.default || m)
  },
  {
    name: "termService___Hk",
    path: "/Hk/termService",
    meta: indexmZQKsbdXAaMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/termService/index.vue").then(m => m.default || m)
  },
  {
    name: "termService___Cn",
    path: "/Cn/termService",
    meta: indexmZQKsbdXAaMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/termService/index.vue").then(m => m.default || m)
  },
  {
    name: "termService___Ja",
    path: "/Ja/termService",
    meta: indexmZQKsbdXAaMeta || {},
    component: () => import("D:/workFile/taro-trip/src/pages/termService/index.vue").then(m => m.default || m)
  }
]